import { axiosBasic, axiosBearer } from "../config/axios-common";
import AcademicCourse from "../models/AcademicCourse";

const postInsertOrUpdateAcademic = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/academicCourse/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const CreateAndGetAcademicCourseFromTasy = async (requestId: string): Promise<AcademicCourse[]> => {

    const response = await axiosBearer.post(`/sam/v1/academicCourse/CreateAndGetAcademicCourseFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

        var result = new Array<AcademicCourse>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let item = AcademicCourse.NewInstance();

                item.Id = row.id;
                item.InstitutionName = row.institutionName;
                item.CourseName = row.courseName;
                item.YearCompletion = row.yearCompletion;
                item.TasyCode = row.tasyCode;
                item.RemoveTasy = row.removeTasy;

                return item;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;

};



const exportedObject = {
    postInsertOrUpdateAcademic,
    CreateAndGetAcademicCourseFromTasy
};


export default exportedObject